// export const END_POINT = "https://bedb-api.labo-linkibe.fr/";
export const END_POINT = "https://api-media.bedb.mc/";

export const FRONT_SITE_URL = "https://bedb-site.labo-linkibe.fr";
// export const FRONT_SITE_URL = "https://localhost:3000";

// export const IMAGE_END_POINT = "https://bedb-api.labo-linkibe.fr";
export const IMAGE_END_POINT = "https://api-media.bedb.mc";


export const ProjectName = "B.E.D.B BÂTIMENT SARL";

export const drawerOnglets = [
  {
    name: "Dashboard",
    icon: "bi-columns-gap",
    to: "/",
    showOnlyToAdmin: false,
    view: "dashboard",
  },
  {
    name: "Projets",
    icon: " bi-file-earmark-fill",
    to: "/projets",
    showOnlyToAdmin: false,
    view: "projets",
  },
  {
    name: "Projet",
    // icon: " bi-file-earmark-fill",
    hideInDrawer: true,
    to: "/projets/:id",
    showOnlyToAdmin: false,
    view: "projetItem",
  },

  /* {
    name: "Blog",
    icon: "bi-file-earmark-fill",
    to: "/blog",
    showOnlyToAdmin: false,
    view: "blog",
  }, */
  // {
  //  name: "Réalisation",
  // icon: "bi-calendar-event",
  //  to: "/realisation",
  // showOnlyToAdmin: false,
  //  view: "events",
  // },
  {
    name: "Pages",
    icon: "bi-file-earmark-code",
    to: "/pages",
    showOnlyToAdmin: false,
    view: "pages",
  },

  // {
  //   name: "Revendeur",
  //   icon: "bi-pin-map",
  //   to: "/showroom",
  //   showOnlyToAdmin: false,
  //   view: "revendeurs",
  // },

  /* {
    name: "Contacts",
    icon: "bi-envelope-fill",
    to: "/contact",
    showOnlyToAdmin: false,
    view: "contacts",
  }, */
  {
    name: "Fichiers",
    icon: "bi-card-image",
    to: "/files",
    showOnlyToAdmin: false,
    view: "fichiers",
  },
  {
    name: "Utilisateurs",
    icon: "bi-people-fill",
    to: "/users",
    showOnlyToAdmin: true,
    view: "users",
  },
  {
    name: "Mon Compte",
    icon: "bi-person-circle",
    to: "/account",
    showOnlyToAdmin: false,
    view: "account",
  },

  //NOT SHOW IN DRAWER

  {
    name: "Articles element",
    hideInDrawer: true,
    to: "/article/:id",
    showOnlyToAdmin: false,
    view: "articleItem",
  },

  // {
  //  name: "Events element",
  //  hideInDrawer: true,
  //  to: "/realisation/:id",
  //  showOnlyToAdmin: false,
  //  view: "eventItem",
  // },

  // {
  //   name: "Revendeurs element",
  //   hideInDrawer: true,
  //   to: "/showroom/:id",
  //   showOnlyToAdmin: false,
  //   view: "showRoomItem",
  // },

  {
    name: "Pages element",
    hideInDrawer: true,
    to: "/pages/:id",
    showOnlyToAdmin: false,
    view: "pageItem",
  },
  {
    name: "Contact element",
    hideInDrawer: true,
    to: "/contact/:id",
    showOnlyToAdmin: false,
    view: "contactItem",
  },
  {
    name: "Nouvel utilisateur",
    hideInDrawer: true,
    to: "/newUser",
    showOnlyToAdmin: true,
    view: "newUser",
  },
];

export const pageNames = {
  blog: "actualites",
  // events: "Realisation",
  home: "Accueil",
  /* products: "Page nos biens", */
  // magasins: "Page Revendeur",
};
export const redirection = {
  // eventRoute: "article",
  blogRoute: "article",
};
